import { useState } from 'react';
import { Image, Modal } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';

export function ImagePreview({ url, name }: { url: string; name?: string }) {
  return <Image src={url} alt={name || 'preview'} className="thumb" width={56} height={56} />;
}

export function VideoPreview({ url, name }: { url: string; name?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="video-thumb-btn" onClick={() => setOpen(true)} title="播放预览">
        <video src={url} className="thumb" muted preload="metadata" />
        <PlayCircleOutlined className="video-thumb-play" />
      </button>
      <Modal
        title={name || '视频预览'}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={720}
        destroyOnClose
        centered
      >
        <video src={url} controls autoPlay style={{ width: '100%', maxHeight: '70vh', background: '#000' }} />
      </Modal>
    </>
  );
}

export function AudioPreview({ url }: { url: string }) {
  return <audio controls preload="metadata" src={url} className="audio-player" />;
}
